export const RESPONSE_MESSAGE = {
  UPDATE_SUCCESS: 'Tag updated successfully.',
  CREATE_SUCCESS: 'Tag created successfully.',
};
